import { atom } from "recoil";

export const selectedComboSnState = atom({
  key: "selectedComboSnState",
  default: 0,
});

export const selectorState = atom({
  key: "questionSelectorState",
  default: {
    combo: "",
    combo_catagory: "",
    room_type: "",
  },
});

export const firstQuestionState = atom({
  key: "firstQuestionState",
  default: {
    text: "",
    langauge: null,
    ready_time_second: 15,
    minres_time_second: 60,
    maxres_time_second: 180,
    url: "",
  },
});

export const secondQuestionState = atom({
  key: "secondQuestionState",
  default: {
    text: "",
    langauge: null,
    ready_time_second: 15,
    minres_time_second: 60,
    maxres_time_second: 180,
    url: "",
  },
});

export const thirdQuestionState = atom({
  key: "thirdQuestionState",
  default: {
    text: "",
    langauge: null,
    ready_time_second: 15,
    minres_time_second: 60,
    maxres_time_second: 180,
    url: "",
  },
});
